import {Box, Button, HStack, Image, Link, Text, Img} from '@chakra-ui/react';
import React from 'react';
import {LinkedinSvg, TwitterSvg} from '../../../assets';
import HeroPrivacyLogoSvg from '../../../assets/images/privacy-policy-hero.png';

const Post = ({data}) => {
    const url = window?.location?.href
    return (
        <Box maxW={'100%'} pr={{base: 0, md: '20px'}}>
            <Box mb={'63px'} maxW={'100%'} textAlign={"center"}>
                
                <Img
                    draggable={'false'}
                    src={HeroPrivacyLogoSvg}
                    alt={'privacy policy'}
                    inset={'0'}
                    maxW={'90%'}
                    width={'600px'}
                    display={'inline-block'}
                />
            </Box>
            <Box mb={'34px'} maxW={'100%'}>
                <Text as={'p'} fontSize={'24'} lineHeight={'31.2px'} textColor={'#333333'}>
                    <div dangerouslySetInnerHTML={{__html: data?.acf?.subheading}}/>
                </Text>
            </Box>
            <Box display={'flex'} alignItems={'center'} mb={'40px'} maxW={'100%'}>
                {data?.coauthors?.map((a, index) => {
                    const children = () => {
                        return (
                            <>
                                {a?.image_url &&
                                    <Image
                                        w={'60px'}
                                        h={'60px'}
                                        src={a?.image_url}
                                        borderRadius={'full'}
                                        mr={'20px'}
                                    />
                                }
                                <Text
                                    as={'span'}
                                    fontWeight={'semibold'}
                                    fontSize={'16px'}
                                    lineHeight={'32px'}
                                    textColor={'brand.700'}
                                >
                                    {a.name}
                                </Text>
                            </>
                        )
                    }
                    if (a?.link_url) {
                        return (
                            <Link href={a?.link_url} display="flex" alignItems="center" key={index}
                                  _hover={{textDecoration: 'none'}} _focus={{boxShadow: 'none'}} mr={2}>
                                {children()}
                            </Link>
                        )
                    }
                    return children()
                })}
            </Box>
            {(data?.title?.raw ? 
            <HStack spacing={'4px'} display={'flex'} alignItems={'center'} maxW={'100%'}
                    mb={{base: '40px', md: '80px'}}>
                <Text as="span">Share</Text>
                <Button
                    size={'xs'}
                    variant={'solid'}
                    bgColor={'transparent'}
                    iconSpacing={0}
                    borderRadius={'full'}
                    as={'a'}
                    href={`http://www.twitter.com/share?url=${url}&text=${encodeURI(data?.title?.raw)}`} target={'_blank'}
                    rel="noopener noreferrer"
                >
                    <TwitterSvg/>
                </Button>
                <Button
                    as={'a'}
                    size={'xs'}
                    variant={'solid'}
                    bgColor={'transparent'}
                    iconSpacing={0}
                    borderRadius={'full'}
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} target={'_blank'}
                    rel="noopener noreferrer"
                >
                    <LinkedinSvg/>
                </Button>
            </HStack>
            : '')}
            <Box mb={'70px'} maxW={'100%'} className="venrock-article-body">
                <Text as={'p'} fontSize={{xs: '16px', md: '24px'}} lineHeight={{xs: '24px', md: '33.6px'}}
                      textColor={'#333333'} sx={{
                    '& p': {
                        mb: '1.25rem !important',
                    },
                    '& ol': {
                        ml: '20px',
                    },
                    '& ul': {
                        ml: '20px',
                    },
                    '& blockquote': {
                        my: '70px',
                        fontSize: '40px',
                        lineHeight: '48px',
                        letterSpacing: '-1px',
                        textColor: `brand.700`,
                        fontWeight: 'semibold'
                    },
                    '& a': {
                        textColor: `brand.700`,
                        textDecoration: 'underline'
                    },
                    '& img': {
                        maxWidth: '100%',
                        width: '100%'
                    }
                }}>
                    <div dangerouslySetInnerHTML={{__html: data?.content?.rendered}}/>
                </Text>
            </Box>
        </Box>
    );
};

export default Post;
